import { render, staticRenderFns } from "./Bangkok.vue?vue&type=template&id=740f138c&"
import script from "./Bangkok.vue?vue&type=script&lang=js&"
export * from "./Bangkok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports